import React from "react";
import Banner from "../../components/banner/Banner";
import "./Beekeepers.css";
import CategoryProducts from "../../components/CategoryProducts/CategoryProducts";
import BeekeeperBenefits from "./BeekeeperBenefits";
import Title from "../../components/titles/Title";
import BPN from "../../assets/images/technology-icons/bpn.svg"
import MP from "../../assets/images/technology-icons/marketplace.svg"
// Beekeepers component
const Beekeepers = () => {
  return (
    <>
      {/* Banner Section */}
      <Banner
        className="beekeeper-bg"
        bannerTitle={[
          <span key="1">Access Colonies Migration service and acquire essential  </span>,
          <br key="2" className="d-lg-block d-none" />,
          <span key="3"> inputs like feed with ease </span>
        ]}
      />

      {/* Migration Services Category Section */}
      <CategoryProducts
        categoryId={["AGR12-100B"]}
        title="Migration Services"
        description="Services not found"
        btn1text="Request Now"
      />

      {/* Buy Inputs Category Section */}
      <CategoryProducts
        categoryId={["AGR10-1010", "AGR10-1005"]}
        title="Buyinputs"
        description="Services not found"
      />

      {/* Benefits Section */}
      <div className="section-container benefit-container">
        <div className="container">
          <Title classname="text-center mb-5" heading="Benefits" />
          <BeekeeperBenefits />
        </div>
      </div>

      {/* Technology Section */}
      <div className="section-container benefit-container">
        <div className="container">
          <div className="section-sub-container text-center">
            <Title classname="text-center mb-4" heading="Our Technology" />

            {/* Bee Production Network Info */}
            <img className="technoloy-icons d-block mb-2 mx-auto mt-4" src={BPN} alt="Bee Production Network" />
            <h5 className="mb-3">Bee Production Network (BPN)</h5>
            <p>
              Bee Production Network (BPN) is an innovative technology solution
              provided by Apischain to empower beekeepers with advanced tools
              for managing their bee colonies and optimizing honey production.
            </p>
            <p>
              Field Officer, Field Inspector, ICS Executive, ICS Manager
            </p>

            {/* Marketplace Info */}
            <img className="technoloy-icons d-block mx-auto mb-2 mt-4" src={MP} alt="Market-Place" />
            <h5 className="mb-3">Marketplace</h5>
            <p>
              Marketplace is a technology platform developed by Apischain that facilitates 
              the buying and selling of products. It connects buyers and sellers in a seamless 
              digital environment, enabling efficient transactions and access to a wide range of goods.
            </p>

          </div>
        </div>
      </div>
    </>
  );
};

export default Beekeepers;
